module.exports = __webpack_public_path__ + "16f8b07d5c38ec025c3a47a3fd8f7520.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/bell.svg
// module id = 731
// module chunks = 0